(function () {
  if (window.__lgCookieBannerLoaded) return;
  window.__lgCookieBannerLoaded = true;

  var root = document.querySelector("[data-lg-cookie-banner]");
  if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== "function") return;

  var modal = root.querySelector("[data-lg-cookie-modal]");
  var openButton = root.querySelector("[data-lg-cookie-open]");
  var acceptButtons = root.querySelectorAll("[data-lg-cookie-accept]");
  var essentialButtons = root.querySelectorAll("[data-lg-cookie-essential]");
  var saveButton = root.querySelector("[data-lg-cookie-save]");
  var closeButtons = root.querySelectorAll("[data-lg-cookie-close]");
  var preferenceField = root.querySelector('[data-lg-cookie-field="preferences"]');
  var analyticsField = root.querySelector('[data-lg-cookie-field="analytics"]');
  var marketingField = root.querySelector('[data-lg-cookie-field="marketing"]');

  function hasDecision(consent) {
    if (!consent) return false;
    return ["preferences", "analytics", "marketing"].some(function (key) {
      return consent[key] === "yes" || consent[key] === "no";
    });
  }

  function setModalOpen(open) {
    if (!modal) return;
    modal.hidden = !open;
    document.documentElement.classList.toggle("lg-cookie-modal-open", open);
  }

  function hideBanner() {
    root.hidden = true;
    setModalOpen(false);
  }

  function syncFields(api) {
    if (!api || typeof api.currentVisitorConsent !== "function") return;
    var consent = api.currentVisitorConsent() || {};

    if (preferenceField) preferenceField.checked = consent.preferences === "" ? true : consent.preferences === "yes";
    if (analyticsField) analyticsField.checked = consent.analytics === "" ? true : consent.analytics === "yes";
    if (marketingField) marketingField.checked = consent.marketing === "" ? false : consent.marketing === "yes";
  }

  function submitConsent(api, payload) {
    if (!api || typeof api.setTrackingConsent !== "function") return;
    api.setTrackingConsent(payload, function () {
      hideBanner();
    });
  }

  window.Shopify.loadFeatures(
    [{ name: "consent-tracking-api", version: "0.1" }],
    function (error) {
      if (error || !window.Shopify.customerPrivacy) return;

      var api = window.Shopify.customerPrivacy;
      syncFields(api);

      var consent = typeof api.currentVisitorConsent === "function" ? api.currentVisitorConsent() : null;
      var shouldShow = typeof api.shouldShowBanner === "function" ? api.shouldShowBanner() : !hasDecision(consent);

      if (shouldShow && !hasDecision(consent)) {
        root.hidden = false;
      }

      if (openButton) {
        openButton.addEventListener("click", function () {
          setModalOpen(true);
        });
      }

      Array.prototype.forEach.call(closeButtons, function (button) {
        button.addEventListener("click", function () {
          setModalOpen(false);
        });
      });

      Array.prototype.forEach.call(acceptButtons, function (button) {
        button.addEventListener("click", function () {
          submitConsent(api, { preferences: true, analytics: true, marketing: true });
        });
      });

      Array.prototype.forEach.call(essentialButtons, function (button) {
        button.addEventListener("click", function () {
          submitConsent(api, { preferences: false, analytics: false, marketing: false });
        });
      });

      if (saveButton) {
        saveButton.addEventListener("click", function () {
          submitConsent(api, {
            preferences: preferenceField ? !!preferenceField.checked : false,
            analytics: analyticsField ? !!analyticsField.checked : false,
            marketing: marketingField ? !!marketingField.checked : false,
          });
        });
      }

      document.addEventListener("visitorConsentCollected", function () {
        hideBanner();
      });
    }
  );
})();
